import { RouteObject } from 'react-router-dom';
import lazyImport from '~/utils/lazyImport';

const CardDetailsView = lazyImport(() => import('~/views/accounts/cards/CardDetails/CardDetailsView'));
const CardCreationView = lazyImport(() => import('./CardCreation/CardCreationView'));
const CardsView = lazyImport(() => import('./CardsView'));

export const cardsRoutes: RouteObject[] = [
  {
    path: 'new',
    element: <CardCreationView />,
  },
  {
    path: ':cardId',
    element: <CardDetailsView activeTab={'details'} />,
  },
  {
    path: ':cardId/transactions',
    element: <CardDetailsView activeTab={'transactions'} />,
  },
  {
    path: ':cardId/settings',
    element: <CardDetailsView activeTab={'settings'} />,
  },
  { path: '*', element: <CardsView /> },
];
